module.exports = __webpack_public_path__ + "img/detrastt.0f47533.png";